import { Dispatch, SetStateAction } from "react";
import { Box, Button, TextField } from "@mui/material";
import Popover from "@mui/material/Popover";

type Props = {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  SetName: Dispatch<SetStateAction<string>>;
  SetNote: Dispatch<SetStateAction<string>>;
  OnSaveClick: () => void;
};

const PopoverComponent = ({
  open = false,
  anchorEl,
  setAnchorEl,
  SetName,
  SetNote,
  OnSaveClick,
}: Props) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Box style={{ padding: "10px" }}>
        <Box display="flex" flexDirection="column">
          <TextField
            style={{ width: "200px" }}
            id="outlined-required"
            label="Name"
            size="small"
            onChange={(e: any) => {
              SetName(e.target.value);
            }}
          />

          <TextField
            style={{ width: "200px", marginTop: "10px" }}
            id="outlined-required"
            label="Note"
            size="small"
            onChange={(e: any) => {
              SetNote(e.target.value);
            }}
          />
        </Box>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ padding: "10px", border: "0px solid red" }}
        >
          <Button
            color="primary"
            variant="contained"
            size="small"
            onClick={OnSaveClick}
          >
            Save Changes
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default PopoverComponent;
